import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function EmailVerify(){
  const [verificationStatus, setVerificationStatus] = useState(null);
  const { token, email } = useParams();
  const navigation = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };
  
  useEffect(() => {
    // Call the API to verify the email
    fetch(apiUrl+`/api/verify-email?token=${token}&email=${email}`,{
      method: 'POST',headers: {
        'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
    }},)
      .then(response => {
        if (response.ok) {
          setVerificationStatus('success');
        } else {
          setVerificationStatus('error');
        }
      })
      .catch(error => {
        console.error('Error verifying email:', error);
        setVerificationStatus('error');
      });
  }, [token, email]);

  useEffect(() => {
    // If verification is successful, navigate to the login page
    if (verificationStatus === 'success') {
      navigation('/login'); // Navigate to the login component
    }
  }, [verificationStatus, navigation]);

  return (
    <div>
      {verificationStatus === 'success' && (
        <h2>Email verified successfully!</h2>
      )}
      {verificationStatus === 'error' && (
        <h2>Error verifying email. Please try again later.</h2>
      )}
      {verificationStatus === null && (
        <h2>Verifying email...</h2>
      )}
    </div>
  );
};

export default EmailVerify;
